export default {
  path: '/stock-buy',
  component: () => import('@/views/stock/stock-router.vue'),
  children: [
    {
      path: '',
      name: 'StockBuy',
      component: () => import('@/views/stock/pages/StockBuy.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },
    {
      path: 'stock-buy-print',
      name: 'StockBuyPrint',
      component: () => import('@/views/stock/print/StockBuyPrint.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'stock-buy-print-id/:id',
      name: 'StockBuyPrintById',
      component: () => import('@/views/stock/print/StockBuyPrintById.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },

    {
      path: 'stock-import',
      name: 'StockImport',
      component: () => import('@/views/stock/pages/StockImport.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },

    {
      path: 'stock-import-print',
      name: 'StockImportPrint',
      component: () => import('@/views/stock/print/StockImportPrint.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },
    {
      path: 'stock-import-print-id/:id',
      name: 'StockImportPrintByid',
      component: () => import('@/views/stock/print/StockImportPrintByid.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    },

    {
      path: 'stock-buy-create',
      name: 'StockBuyCreate',
      component: () => import('@/views/stock/pages/StockBuyCreate.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },
    {
      path: 'stock-buy-edit/:id',
      name: 'StockBuyEdit',
      component: () => import('@/views/stock/pages/StockBuyEdit.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },
    {
      path: 'stock-buy-detail/:id',
      name: 'StockBuyDetail',
      component: () => import('@/views/stock/pages/StockBuyDetail.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },

    {
      path: 'stock-import-create',
      name: 'StockImportCreate',
      component: () => import('@/views/stock/pages/StockImportCreate.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },
    {
      path: 'stock-import-edit/:id',
      name: 'StockImportEdit',
      component: () => import('@/views/stock/pages/StockImportEdit.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    },
    {
      path: 'stock-import-detail/:id',
      name: 'StockImportDetail',
      component: () => import('@/views/stock/pages/StockImportDetail.vue'),
      meta: {
        name: 'navigationDrawer.stock',
        icon: '/icons/stock.svg',
        auth: true
      }
    }
  ]
}
